import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { HomeSimulation } from '@models/swagger';
import { SimulationParams } from './service';

export enum SimulationActions {
  Failure = '[Project Simulation] Failure',
  Request = '[Project Simulation] Request',
  Success = '[Project Simulation] Success',
}

export const SimulationFailure = createAction(SimulationActions.Failure, props<{ error: HttpErrorResponse }>());

export const SimulationRequest = createAction(SimulationActions.Request, props<{ parameters: SimulationParams }>());

export const SimulationSuccess = createAction(SimulationActions.Success, props<{ data: HomeSimulation[] }>());
